import type { BasicRoleDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SmartInvoicingRoleService {
  apiName = 'Default';
  

  getAllRolesByNameByName = (name: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BasicRoleDto[]>({
      method: 'GET',
      url: '/api/app/smart-invoicing-role/roles-by-name',
      params: { name },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
